/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  select-account-reducer.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Deepthi Bachu(E844276)
 *
 * @Date         : Jan 28, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Deepthi Bachu(E844276)
 * On            : Jan 28, 2020
 * Description   : ASDS-2048 - Admin Functionality
 *
 * By            : Deepthi Bachu - E844276
 * On            : 11 Feb, 2020
 * Description   : ASDS-2197 - Select Account - Integrate Search by Type API Integration - New Changes
 *
 * By            : Deepthi Bachu - E844276
 * On            : 04 Mar, 2020
 * Description   : ASDS-2409 - NGBSS place order service - address parameter changes
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes. Added method to reset select account data.
 *
 * By            : H422335
 * On            : Oct 09, 2020
 * Description   : ASDS-3035 Migration of backend URLs to Forge endpoints
 ******************************************************************************/

 import Reducer from './reducer';
 import { AsdsReduxAction, AsdsReducerObject } from '../../../../types';
 import ActionConstants from '../action-constants';
 import { createReducer } from '../utils/redux-util';
 import { SelectAccountInfo } from '../../utils/checkout-interfaces';
 import CheckoutConstants from 'modules/checkout/constants/checkout-constants';

 const initialState = {
    selectAccountDetails: {
        isFetching: true,
        isSuccess: false,
        payload: {
            accountId: '',
            customerName: '',
            soldTo: {},
            shipTo: {},
        },
        searchBy: CheckoutConstants.SELECT_ACCOUNT_SEARCH_BY_HONID
    },
    adminAddressDetails: {
        isFetching: true,
        isSuccess: false,
    }
};

 class SelectAccountReducer extends Reducer {

    static setSelectAccount(_state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            ..._state,
            selectAccountDetails: {
                isFetching: false,
                isSuccess: action.payload.isSuccess,
                searchBy: _state.selectAccountDetails.searchBy,
                payload: {
                    ..._state.selectAccountDetails.payload,
                    ...action.payload.selectAccountDetails,
                },
            },

        };
    }

    static setAdminAccountAddresses(state, action: AsdsReduxAction): AsdsReducerObject {
        const addressDetails: SelectAccountInfo = action.payload.response;
        return {
            ...state,
            adminAddressDetails: {
                isSuccess: action.payload.isSuccess,
                isFetching: action.payload.isFetching,
                data: addressDetails,
            },
        };
    }

    static updateSearchBy(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            ...state,
            selectAccountDetails: {
                isFetching: state.selectAccountDetails.isFetching,
                isSuccess: state.selectAccountDetails.isSuccess,
                payload: state.selectAccountDetails.payload,
                searchBy: action.payload.searchBy,
            }
        };
    }

    static resetSelectAccountDetails ()  {
        return initialState;
    }

}

 const selectAccountHandlers = {
    [ActionConstants.SET_SELECT_ACCOUNT]: SelectAccountReducer.setSelectAccount,
    [ActionConstants.SET_ADMIN_ACCOUNT_ADDRESSES]: SelectAccountReducer.setAdminAccountAddresses,
    [ActionConstants.UPDATE_SEARCH_BY]: SelectAccountReducer.updateSearchBy,
    [ActionConstants.RESET_SELECT_ACCOUNT]: SelectAccountReducer.resetSelectAccountDetails
};

 export const selectAccount = createReducer(initialState, selectAccountHandlers);
